import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'meta.title.billing',
    defaultMessage: 'Billing',
    description: 'Extra information to be added to the page title in the html head element.'
  }
});

const billing = {
  path: 'billing',

  name: 'billing',

  meta: {
    title: messages.title
  },

//  indexRoute: {
//    async getComponent() {
//      const { BillingIndex } = await import('./BillingRoutes');
//
//      return BillingIndex;
//    }
//  },

  async getComponent() {
    const {BillingMain} = await import('./BillingRoutes');

    return BillingMain;
  },

  async getChildRoutes() {
    const {BillingRoutes} = await import('./BillingRoutes');

    return BillingRoutes;
  }
};

export default billing;



// WEBPACK FOOTER //
// ./src/apps/Billing/index.js